import Header from "@/components/Header";

const AvisoPrivacidad = () => (
  <>
    <Header />
    <main className="min-h-screen bg-slate-50 px-4 py-24">
      <section className="mx-auto max-w-4xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-black uppercase tracking-wide text-[#F97316]">
          Tulocalmx
        </p>
        <h1 className="mt-2 text-3xl font-black text-slate-950">
          Aviso de privacidad
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Última actualización: junio de 2026.
        </p>

        <div className="mt-6 space-y-5 text-sm leading-7 text-slate-700">
          <p>
            Tulocalmx utiliza los datos que proporcionas para crear y administrar
            tu cuenta, recibir propiedades para publicación, revisar la calidad de
            la información, mostrar publicaciones autorizadas y contactarte sobre
            tus anuncios o solicitudes.
          </p>

          <section>
            <h2 className="font-black text-slate-950">Datos que podemos recopilar</h2>
            <p>
              Nombre, correo electrónico, teléfono, tipo de usuario, ubicación de
              la propiedad, descripción, precio, medidas, servicios, disponibilidad,
              fotos, videos, documentos y cualquier información que captures en los
              formularios de Tulocalmx.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Uso de la información</h2>
            <p>
              Usamos la información para validar publicaciones, mostrar propiedades
              aprobadas en el sitio, permitirte administrar tus anuncios, enviarte
              avisos de cuenta, recuperar contraseña, atender solicitudes y mejorar
              la experiencia del servicio.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Publicación de datos</h2>
            <p>
              Solo las propiedades marcadas como publicadas se muestran al público.
              Los datos internos de cuenta, revisión y administración no se muestran
              públicamente salvo la información necesaria para promocionar la propiedad.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Servicios de terceros</h2>
            <p>
              Podemos usar proveedores tecnológicos como Supabase, Vercel,
              Cloudinary, EmailJS, Google Maps u otros servicios necesarios para
              autenticación, almacenamiento, envío de correos, publicación de fotos
              y funcionamiento del sitio.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Seguridad</h2>
            <p>
              Aplicamos controles de acceso para que cada usuario pueda ver y
              administrar sus propias propiedades. Aun así, ninguna plataforma en
              internet puede garantizar seguridad absoluta, por lo que recomendamos
              usar contraseñas seguras y no compartir accesos.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Derechos del usuario</h2>
            <p>
              Puedes solicitar acceso, corrección, actualización o baja de tus datos
              y publicaciones contactando a Tulocalmx por los medios disponibles en
              el sitio.
            </p>
          </section>
<section>
  <h2 className="font-black text-slate-950">Uso de herramientas de inteligencia artificial</h2>

  <p>
    TuLocalmx podrá utilizar herramientas de inteligencia artificial y sistemas
    automatizados como apoyo para analizar información relacionada con propiedades,
    zonas, giros comerciales, ubicación, características del inmueble, competencia
    cercana, perfil de interesados y otros datos necesarios para mejorar la
    experiencia del usuario dentro de la plataforma.
  </p>

  <p>
    El uso de inteligencia artificial tiene fines informativos, orientativos y de
    apoyo para la toma de decisiones. Los resultados, recomendaciones, análisis de
    zona, compatibilidades comerciales o respuestas generadas por herramientas de
    IA pueden contener errores, imprecisiones, información incompleta o variaciones
    respecto a la realidad actual del mercado.
  </p>

  <p>
    La información generada por inteligencia artificial no debe considerarse como
    asesoría legal, fiscal, financiera, inmobiliaria definitiva ni como garantía
    de éxito comercial, rentabilidad, afluencia de clientes, aprobación de
    contratos o cierre de operaciones. El usuario deberá verificar la información,
    visitar el inmueble, revisar documentación, consultar a especialistas cuando
    sea necesario y tomar su decisión bajo su propio criterio.
  </p>

  <p>
    TuLocalMX podrá apoyarse en proveedores tecnológicos externos para procesar
    información mediante herramientas de inteligencia artificial, procurando en
    todo momento proteger los datos personales conforme a este Aviso de Privacidad
    y a la legislación aplicable.
  </p>
</section>
          <section>
            <h2 className="font-black text-slate-950">Cambios al aviso</h2>
            <p>
              Tulocalmx puede actualizar este aviso para reflejar cambios del
              servicio, requisitos operativos o disposiciones aplicables. La versión
              vigente estará disponible en esta página.
            </p>
          </section>
        </div>
      </section>
    </main>
  </>
);

export default AvisoPrivacidad;
